import { useId } from 'react';

import Text from '../../components/Text';

/**
 * Zone de saisie sur plusieurs lignes, sur le modèle de l'`Input` du socle : libellé
 * VISIBLE et accessible, police ≥ 16 px (en dessous, iOS zoome au focus et ne
 * dézoome jamais), zone tactile de 44 px.
 */
interface ChampTexteProps {
    libelle: string;
    valeur: string;
    onChange: (valeur: string) => void;
    aide?: string;
}

export default function ChampTexte({ libelle, valeur, onChange, aide }: ChampTexteProps) {
    const id = useId();

    return (
        <div className="flex flex-col gap-1.5">
            <label htmlFor={id}>
                <Text variante="petit" ton="attenue" as="span">
                    {libelle}
                </Text>
            </label>
            <textarea
                id={id}
                value={valeur}
                rows={2}
                onChange={(e) => onChange(e.target.value)}
                className="min-h-touch w-full rounded-xl border border-border-color-light bg-white px-4 py-3 text-base text-text-color"
            />
            {aide && (
                <Text variante="petit" ton="attenue" as="span">
                    {aide}
                </Text>
            )}
        </div>
    );
}
